import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { AndrichLogo } from "../components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("andrich_admin_token", data.token);
      localStorage.setItem("andrich_admin_user", JSON.stringify(data.user));
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 grid place-items-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-blue-900 mb-6" data-testid="admin-back-home">
          <ArrowLeft size={14} /> Back to site
        </Link>
        <div className="bg-white rounded-3xl border border-slate-200 shadow-xl p-8">
          <AndrichLogo />
          <h1 className="mt-6 font-display text-2xl font-semibold text-slate-900">Admin Sign In</h1>
          <p className="mt-1 text-sm text-slate-500">Manage products and view inquiries.</p>

          <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="admin-login-form">
            <label className="block">
              <span className="text-[0.7rem] tracking-[0.22em] uppercase text-slate-500 font-medium">Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 w-full px-4 py-3 rounded-full bg-slate-50 border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 outline-none text-sm"
                data-testid="admin-email-input"
              />
            </label>
            <label className="block">
              <span className="text-[0.7rem] tracking-[0.22em] uppercase text-slate-500 font-medium">Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 w-full px-4 py-3 rounded-full bg-slate-50 border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 outline-none text-sm"
                data-testid="admin-password-input"
              />
            </label>
            <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-login-submit">
              {loading ? (<><Loader2 size={16} className="animate-spin mr-2" /> Signing in…</>) : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
